import type { AssetInstallmentPlan } from "./asset-installments.js";
import type { InternalCenterFicActual } from "./catalog-invoices.js";
import { Type, type Static } from "@sinclair/typebox";
const operation = { operationId: Type.String({ format: "uuid" }) };
export const InternalCenterQuerySchema = Type.Object(
  { managementYear: Type.Integer({ minimum: 2000, maximum: 2200 }) },
  { additionalProperties: false },
);
export const InternalCenterOpenSchema = Type.Object(
  {
    ...operation,
    managementYear: Type.Integer({ minimum: 2000, maximum: 2200 }),
  },
  { additionalProperties: false },
);
export const InternalCenterUpdateSchema = Type.Object(
  {
    ...operation,
    version: Type.Integer({ minimum: 1 }),
    name: Type.String({ minLength: 1, maxLength: 160 }),
    active: Type.Boolean(),
  },
  { additionalProperties: false },
);
export const InternalCenterDeleteSchema = Type.Object(
  { ...operation, version: Type.Integer({ minimum: 1 }) },
  { additionalProperties: false },
);
export const InternalCenterWarehouseSchema = Type.Object(
  {
    ...operation,
    version: Type.Integer({ minimum: 1 }),
    managementYear: Type.Integer({ minimum: 2000, maximum: 2200 }),
    enabled: Type.Boolean(),
  },
  { additionalProperties: false },
);
export type InternalCenterWarehouse = Static<
  typeof InternalCenterWarehouseSchema
>;
export type InternalCenterUpdate = Static<typeof InternalCenterUpdateSchema>;
export interface InternalCenterDetail {
  assetInstallments?: AssetInstallmentPlan | null;
  originalRecordedAmount?: string;
  ficActual?: InternalCenterFicActual;
  invoiceIntegrationEnabled?: boolean;
  budgetRemoved?: boolean;
  simulatorManaged?: boolean;
  structureAllocationAmount?: string;
  id: string;
  code: string;
  name: string;
  costType: string;
  active: boolean;
  version: number;
  managementYear: number;
  jobId: string | null;
  warehouseEnabled: boolean;
  budgetAmount: string;
  budgetVersion: number | null;
  budgetConfigured?: boolean;
  actualAmount: string;
  legacyAmount: string;
  laborAmount: string;
  materialAmount: string;
  entries: {
    id: string;
    date: string;
    description: string | null;
    amount: string;
    imported: boolean;
  }[];
}
